<template>
  <v-dialog
    v-model="exibirModalBandeirasCheckinpay"
    width="90vw"
    max-width="1000px"
    persistent
  >
    <Loading v-if="loading" />
    <div
      style="display: flex; flex-direction: column; background-color: white"
      v-if="!loading"
    >
      <v-toolbar
        color="blue"
        style="
          color: white;
          display: flex;
          flex-direction: column;
          padding-top: 5px;
          padding-bottom: 5px;
          width: 100%;
        "
      >
        <div
          style="
            min-width: 100% !important;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <span class="toolbar-title" style="width: 80%; padding: 10px">
            Bandeiras Checkinpay
          </span>
          <span style="width: 5%">
            <v-btn
              x-small
              color="red"
              @click="() => this.$emit('setExibirModalBandeirasCheckinpay')"
              title="Fechar"
            >
              <v-icon x-small style="color: white">mdi-close</v-icon>
            </v-btn>
          </span>
        </div>
      </v-toolbar>
      <v-data-table v-if="!loading" :headers="headers" :items="bandeiras">
        <template v-slot:[`item.descricao_hospede`]="{ item }">
          <input
            class="inputTextEnviarMensagem"
            v-model="item.descricao_hospede"
            type="text"
            placeholder="Descrição Checkinpay"
          />
        </template>

        <template v-slot:[`item.ativo`]="{ item }">
          <v-switch v-model="item.ativo"></v-switch>
        </template>
        <template v-slot:[`item.intervalo`]="{ item }">
          <div style="display: flex; gap: 5px">
            <input
              class="inputTextParcela"
              v-model="item.intervalo_inicial"
              type="text"
              placeholder="Inicial"
            />
            <input
              class="inputTextParcela"
              v-model="item.intervalo_final"
              type="text"
              placeholder="Final"
            />
          </div>
        </template>
      </v-data-table>
    </div>
    <div
      style="
        display: flex;
        flex-direction: column;
        padding: 10px;
        width: 100%;
        align-items: flex-end;
        background-color: white;
      "
    >
      <button class="buttonsalvar" @click="salvar">Salvar</button>
    </div>
  </v-dialog>
</template>

<script>
import Loading from "../ConfiguracoesWebCheckin/Loading.vue";
export default {
  props: ["exibirModalBandeirasCheckinpay"],
  components: {
    Loading,
  },
  data() {
    return {
      headers: [
        { text: "id", value: "id" },
        { text: "Bandeira", value: "descricao" },
        { text: "Descrição Checkinpay", value: "descricao_hospede" },
        { text: "Ativo", value: "ativo" },
        { text: "Intervalo de Parcelas", value: "intervalo" },
      ],
      bandeiras: null,
      loading: true,
      textoBotaoSalvar: "Salvar",
    };
  },
  methods: {
    async requisitarBandeiras() {
      try {
        const result = await this.$http.post("/checkinpay/getBandeiras");
        const bandeirasMap = result.data.map((bandeira) => {
          return {
            ...bandeira,
            intervalo_inicial:
              bandeira?.intervalos_parcela?.length > 1
                ? bandeira.intervalos_parcela.split(",")[0]
                : null,
            intervalo_final:
              bandeira?.intervalos_parcela?.length > 1
                ? bandeira.intervalos_parcela.split(",")[1]
                : null,
          };
        });
        this.bandeiras = bandeirasMap;
      } catch (error) {
        console.log(error);
      }
    },
    async salvar() {
      this.loading = true;
      const saveBandeiras = this.bandeiras.map((bandeira) => {
        delete bandeira.intervalos_parcela;
        console.log(bandeira);
        return {
          ...bandeira,
          intervalos_parcela:
            bandeira?.intervalo_inicial !== "" && bandeira?.intervalo_inicial
              ? `${bandeira?.intervalo_inicial?.trim()},${bandeira?.intervalo_final?.trim()}`.trim()
              : null,
        };
      });
      console.log(saveBandeiras);
      try {
        await this.$http.post("/checkinpay/saveBandeiras", saveBandeiras);
        alert("Bandeiras salva com sucesso");
      } catch (error) {
        alert("Erro ao salvar bandeiras");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.requisitarBandeiras();
    this.loading = false;
  },
};
</script>

<style scoped>
.buttonsalvar {
  background-color: #2b81d6;
  color: white;
  border-radius: 5px;
  padding: 5px;
  font-size: small;
  font-weight: 100;
  width: 100px;
}
.inputTextEnviarMensagem {
  background-color: white;
  border: 1px solid rgb(148, 148, 148);
  width: 50%;
  border-radius: 10px;
  padding: 1%;
}

.inputTextParcela {
  background-color: white;
  border: 1px solid rgb(148, 148, 148);
  border-radius: 10px;
  padding: 1%;
  width: 100px;
}
</style>
